if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.formQuantity = this.form.querySelector('[name=quantity]');
      this.quantityBubble = this.form.querySelector('.quantity-bubble');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.setupEventListeners();

      this.setupQuantityAmender();
    }

    setupEventListeners() {
      document.addEventListener('quantityUpdated', (e) => {
        if (this.querySelector(`#Quantity-${e.detail.id}`) !== null) {
          let updatedItem = this.querySelector(`#quantityBubble--${e.detail.id}`),
              newQuantity = parseInt(e.detail.qty),
              quantityItem = this.querySelector(`#Quantity-${e.detail.id}`),
              totalMaxQuantity = parseInt(quantityItem.getAttribute('total-max')),
              addableQuantity = totalMaxQuantity - newQuantity,
              button = this.querySelector(`[data-product-id="${e.detail.id}"]`);
          updatedItem.textContent = newQuantity;
          quantityItem.setAttribute('max', addableQuantity);
          newQuantity == totalMaxQuantity ? this.changeButtonStatus(button,'disable') : this.changeButtonStatus(button,'enable');
          newQuantity == 0 && updatedItem.classList.add('hidden');
        }
      });
    }

    setupQuantityAmender() {
      this.querySelectorAll('.amend-quantity').forEach((item) => {
        item.addEventListener('click', (e) => {
          e.target.closest('quantity-input').classList.remove('full-pack');
        })
      });
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cartNotification) {
        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cartNotification.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            this.error = true;
            return;
          } else if (!this.cartNotification) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', id: this.form.querySelector('.product-button').dataset.productId});
          this.error = false;
          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          let newQuantity = parseInt(this.quantityBubble.textContent) + parseInt(this.formQuantity.value);
          this.quantityBubble.textContent = newQuantity;
          this.quantityBubble.classList.remove('hidden');
          if (this.cartNotification && this.cartNotification.classList.contains('is-empty')) this.cartNotification.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    changeButtonStatus(button,status) {
      status == 'disable' ? button.disabled = true : button.disabled = false;
    }
  });
}
